/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to mark an activity feed entry as read in a given context
 * @export
 * @interface MarkAsReadCommand
 */
export interface MarkAsReadCommand {
    /**
     * Reading context (1 = GlobalNotification, 2 = RiskHistory)
     * @type {number}
     * @memberof MarkAsReadCommand
     */
    contexte: MarkAsReadCommandContexteEnum;
}


/**
 * @export
 */
export const MarkAsReadCommandContexteEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type MarkAsReadCommandContexteEnum = typeof MarkAsReadCommandContexteEnum[keyof typeof MarkAsReadCommandContexteEnum];


/**
 * Check if a given object implements the MarkAsReadCommand interface.
 */
export function instanceOfMarkAsReadCommand(value: object): value is MarkAsReadCommand {
    if (!('contexte' in value) || value['contexte'] === undefined) return false;
    return true;
}

export function MarkAsReadCommandFromJSON(json: any): MarkAsReadCommand {
    return MarkAsReadCommandFromJSONTyped(json, false);
}

export function MarkAsReadCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAsReadCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'contexte': json['contexte'],
    };
}

export function MarkAsReadCommandToJSON(json: any): MarkAsReadCommand {
    return MarkAsReadCommandToJSONTyped(json, false);
}

export function MarkAsReadCommandToJSONTyped(value?: MarkAsReadCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contexte': value['contexte'],
    };
}

